module.exports = __webpack_public_path__ + "00_glasses.1f63cd58.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer4/00_glasses.png
// module id = /ofx
// module chunks = 0